import type { SyncedPrinterGroup } from '@/types/api';

const PRINTER_GROUP_TYPES: Record<string, string> = {
  '1': 'Kitchen',
  '2': 'Bar',
  '3': 'Receipt',
};

interface PrinterGroupFormProps {
  formData: Partial<SyncedPrinterGroup>;
  onChange: (data: Partial<SyncedPrinterGroup>) => void;
}

export function PrinterGroupForm({ formData, onChange }: PrinterGroupFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
        <input
          type="text"
          value={formData.name || ''}
          onChange={(e) => onChange({ ...formData, name: e.target.value })}
          className="input w-full"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
        <select
          value={formData.type || ''}
          onChange={(e) => onChange({ ...formData, type: e.target.value || undefined })}
          className="input w-full"
        >
          <option value="">-- Select --</option>
          {Object.entries(PRINTER_GROUP_TYPES).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      </div>
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={formData.isDefault ?? false}
          onChange={(e) => onChange({ ...formData, isDefault: e.target.checked })}
          className="rounded border-gray-300"
        />
        <span className="text-sm text-gray-700">Default</span>
      </label>
    </div>
  );
}
